/* eslint-disable ascii/valid-name */
import {ItemType, QuestionType} from 'common/constants/survey';
import {SurveySettings} from 'common/models/survey';
import {isEmpty} from 'lodash';

import {AppInstallation} from '../../common/constants';

import {initUserCounters, metrika, userCounters} from './initMetrika';
import isSeries from './isSeries';

const {iframe, preview, theme, user, appInstallation} = window.YC;

export enum GoalType {
    StartChange = 'ya-forms_start-change',
    Submit = 'ya-forms_submit',
    Next = 'ya-forms_next',
    Prev = 'ya-forms_prev',
    Teaser = 'success-teaser-click',
}

export const hit = (url: string) => {
    metrika.hit(url);
    if (userCounters) {
        userCounters.forEach((counter) => counter.hit(url));
    }
};

export const goal = (goalType: GoalType) => {
    metrika.reachGoal(goalType);
    if (userCounters) {
        userCounters.forEach((counter) => counter.reachGoal(goalType));
    }
};

export const common = () => {
    metrika.params({
        iframe,
        preview,
        theme,
        login: Boolean(user?.login),
    });
};

export interface QuestionsStats {
    qnNum: number;
    qnNumBy10: number;
    qnNumBy100: number;
}

export const getQuestionsStats = (survey: SurveySettings): QuestionsStats | null => {
    if (isEmpty(survey)) {
        return null;
    }
    const qnNum = survey.pages.reduce((acc, page) => {
        let questionsNum = 0;
        page.items.forEach((question) => {
            if (isSeries(question) && Array.isArray(question.items)) {
                questionsNum += question.items.length;
            } else {
                questionsNum++;
            }
        });
        return acc + questionsNum;
    }, 0);
    const qnNumBy10 = Math.ceil(qnNum / 10) * 10;
    const qnNumBy100 = Math.ceil(qnNum / 100) * 100;

    return {
        qnNum,
        qnNumBy10,
        qnNumBy100,
    };
};

export interface UserCounter {
    reachGoal: (type: GoalType) => void;
    hit: (url: string) => void;
}

export const counterSettings = {
    webvisor: false,
    clickmap: true,
    trackLinks: true,
    defer: false,
    accurateTrackBounce: true,
    triggerEvent: true,
    params: {},
};

export const surveyPage = (survey: SurveySettings, questionsStats: QuestionsStats) => {
    let isOrg = {};
    if (appInstallation === AppInstallation.Business) {
        isOrg = {
            is_org: Boolean(survey.org),
        };
    }
    const params = {
        page: 'survey',
        form_id: survey.id,
        form_style: Boolean(survey.styles),
        ...questionsStats,
        ...isOrg,
    };

    metrika.params(params);

    initUserCounters(survey, counterSettings);
};

export const startChange = (questionsStats: QuestionsStats) => {
    metrika.params({
        'Начало заполнения формы': questionsStats,
    });
    goal(GoalType.StartChange);
};

export const submit = (questionsStats: QuestionsStats) => {
    metrika.params({
        'Отправка формы': questionsStats,
    });
    goal(GoalType.Submit);
};

export const results = () => {
    metrika.params({
        'Результаты заполнения': 'Показ',
    });
};

export const redirect = (delayed?: boolean, clicked?: boolean) => {
    metrika.params({
        'Редирект после отправки': {
            'Кнопка перехода на сайт': {
                [delayed ? 'Отложенный' : 'По кнопке']: clicked ? 'Клик' : 'Показ',
            },
        },
    });
};

export const promo = () => {
    metrika.params({
        'Слайдер промо': 'Клик по кнопке',
    });
    goal(GoalType.Teaser);
};

export const share = (click?: string) => {
    metrika.params({
        Поделяшка: {
            [click ? 'Нажатие' : 'Просмотр']: click ? click : 'normal',
        },
    });
};

export const error = () => {
    metrika.params({
        'ya-forms_error': true,
    });
};

export enum DefaultValueType {
    Query = 'query',
    Storage = 'storage',
    Embed = 'embed',
    Backend = 'backend',
}

export const defaultValues = (type: DefaultValueType, questionType: QuestionType | ItemType) => {
    metrika.params({
        Предзаполнение: {
            [type]: questionType,
        },
    });
};
